import regExpression from 'shared/constants/regExpression';


const EMAIL = 'email';

const getExpression = (rexExpFor: string) => (
  regExpression[rexExpFor]
);

export const validateEmail = (email: string) => {
  const emailRegExp = getExpression(EMAIL);
  const valid = emailRegExp.test(email);
  if (valid) {
    return true;
  }
  return false;
};
